import { FirstLandRoutes } from "single-spa/react-app/router/utils/paramsRouting/constants";
import type { FirstLandingState } from "single-spa/react-app/router/utils/paramsRouting/types";

export const getHasEmptyState = (state: FirstLandingState, isFirstLand: boolean) =>
    state === FirstLandRoutes.WebsiteAnalysisSearch && isFirstLand;
